var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpacePlanet4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_336_31072)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_31072)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    rx: 61,
    fill: "#F9F7B2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_336_31072)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.8149,
    cy: 50.5342,
    rx: 66.185,
    ry: 64.8873,
    fill: "#EFAA86"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_f_336_31072)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.1222,
    cy: 32.6785,
    rx: 40.9146,
    ry: 39.9405,
    fill: "#DDFAEE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_336_31072)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3306,
    cy: 10.3699,
    rx: 17.3306,
    ry: 10.3699,
    transform: "matrix(0.981993 -0.188915 0.196258 0.980552 51.8501 98.646)",
    fill: "#F4DACB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_336_31072",
    x: 0,
    y: 0,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_336_31072"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.645509 0 0 0 0 0.576042 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_336_31072"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_336_31072",
    x: -70.3701,
    y: -74.353,
    width: 252.37,
    height: 249.774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_336_31072"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_336_31072",
    x: -44.7925,
    y: -57.262,
    width: 181.829,
    height: 179.881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_336_31072"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_336_31072",
    x: 23.7622,
    y: 64.855,
    width: 94.2832,
    height: 81.3706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_336_31072"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_31072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 122,
    rx: 61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacePlanet4);
export default __webpack_public_path__ + "static/media/spacePlanet4.c1c61ac98e8a587f6f033b4599b5b1f0.svg";
export { ForwardRef as ReactComponent };